.am{flex:1;}